interface ProfileStarIconProps {
  className?: string
}

export function ProfileStarIcon({ className }: ProfileStarIconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 104 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2 10) scale(0.8)">
        <path
          d="M76.7667 2.94867L112.107 83.6322L95.6102 109.232L65.6568 106.003L54.9234 77.7738L83.9205 80.8999L83.5987 80.1216L61.6561 26.9939L61.3156 26.1705L60.7902 26.8898L43.8901 50.0133L33.4887 23.9072L49.4145 -8.11862e-05L76.7667 2.94867ZM43.5962 50.4158L43.701 50.6736L54.5318 77.4251L28.0272 74.5678L11.4925 98.7021L0.000125171 71.5463L17.0267 47.3677L43.7207 50.2455L43.5962 50.4158Z"
          fill="#383843"
        />
      </g>
    </svg>
  )
}
